import React from 'react';

export const School = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M29.3332 12L15.9998 6.66663L2.6665 12L15.9998 17.3333L29.3332 12ZM29.3332 12V20M7.99984 14.1333V21.3333C7.99984 22.3942 8.84269 23.4116 10.343 24.1617C11.8433 24.9119 13.8781 25.3333 15.9998 25.3333C18.1216 25.3333 20.1564 24.9119 21.6567 24.1617C23.157 23.4116 23.9998 22.3942 23.9998 21.3333V14.1333"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
